<template>
  <div @click="videoSelected()" class="video">
    <iframe width="150" height="100" :src="video.id" allowfullscreen></iframe>
     <div class="video-titles">
       <h5 class="title"> {{video.title}} </h5>
       <p class="description"> {{ video.description }} </p>
     </div>
  </div>
</template>

<script>
export default {
  name: 'video-card',
  props: {
    video: {
      type: Object,
      require: true
    }
  },
  methods: {
    videoSelected (video) {
      this.$emit('videoSelected', video)
    }
  }
}
</script>

<style lang="scss" scoped>

  .video:hover{
    background-color: #DCF2FF;
  }
  .video-titles{
    text-align: start;
    .title{font-size: 17px; line-height: 20px; color: #000;}
    .description{font-size: 15px; line-height: 17px; color: #565656;}
  }
</style>
